/**
 * TAA (Taalbegrip) Module Seeds - Consolidated Index
 *
 * Phase H-8: Migrated from flat seed_TAA.json to folder-based pattern.
 */

import TAA_ONT_BASIS from './TAA-ONT-BASIS.json'
import TAA_SOORT_LID from './TAA-SOORT-LID.json'
import TAA_SOORT_WW from './TAA-SOORT-WW.json'
import TAA_LEZEN_VERW from './TAA-LEZEN-VERW.json'
import TAA_ONT_LV_MV from './TAA-ONT-LV-MV.json'
import TAA_SOORT_VNW from './TAA-SOORT-VNW.json'
import TAA_LEZEN_KERN from './TAA-LEZEN-KERN.json'
import TAA_ONT_BWB from './TAA-ONT-BWB.json'
import TAA_LEZEN_FEIT from './TAA-LEZEN-FEIT.json'
import TAA_LEZEN_VERB from './TAA-LEZEN-VERB.json'
import TAA_SIGNAALWOORD from './TAA-SIGNAALWOORD.json'
import TAA_TEKSTSOORT from './TAA-TEKSTSOORT.json'
import TAA_WOORD_SYNONIEM from './TAA-WOORD-SYNONIEM.json'

const TAA_FAMILY_SEEDS = [
  { file: 'src/data/seeds/TAA/TAA-ONT-BASIS.json', data: TAA_ONT_BASIS },
  { file: 'src/data/seeds/TAA/TAA-SOORT-LID.json', data: TAA_SOORT_LID },
  { file: 'src/data/seeds/TAA/TAA-SOORT-WW.json', data: TAA_SOORT_WW },
  { file: 'src/data/seeds/TAA/TAA-LEZEN-VERW.json', data: TAA_LEZEN_VERW },
  { file: 'src/data/seeds/TAA/TAA-ONT-LV-MV.json', data: TAA_ONT_LV_MV },
  { file: 'src/data/seeds/TAA/TAA-SOORT-VNW.json', data: TAA_SOORT_VNW },
  { file: 'src/data/seeds/TAA/TAA-LEZEN-KERN.json', data: TAA_LEZEN_KERN },
  { file: 'src/data/seeds/TAA/TAA-ONT-BWB.json', data: TAA_ONT_BWB },
  { file: 'src/data/seeds/TAA/TAA-LEZEN-FEIT.json', data: TAA_LEZEN_FEIT },
  { file: 'src/data/seeds/TAA/TAA-LEZEN-VERB.json', data: TAA_LEZEN_VERB },
  { file: 'src/data/seeds/TAA/TAA-SIGNAALWOORD.json', data: TAA_SIGNAALWOORD },
  { file: 'src/data/seeds/TAA/TAA-TEKSTSOORT.json', data: TAA_TEKSTSOORT },
  {
    file: 'src/data/seeds/TAA/TAA-WOORD-SYNONIEM.json',
    data: TAA_WOORD_SYNONIEM,
  },
] as const

const allQuestions = TAA_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Taalbegrip' as const,
  moduleCode: 'TAA',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
